// Anonymous device identity — replaces sign-in. A UUID generated once per
// browser and sent as X-Device-Id on every API call. The $2 unlock, favorites
// and saved quizzes are all keyed to this ID.
//
// Security note: localStorage is appropriate here. The ID is a random opaque
// token containing no personal data; possessing it grants nothing beyond what
// the holder's own browser already has (their own saves/unlock). Server-side,
// the unlock is validated against the payments DB, so the ID cannot be forged
// into a paid entitlement.
const KEY = "fetchright.device_id";

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}
